var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33333C1.66666 8.33333 1.76776 7.62563 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967C16.341 5.73443 17.0111 7.0006 17.3135 8.33333M1.66666 8.33333V3.33333M1.66666 8.33333H6.66666M18.3333 11.6667C18.3333 11.6667 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C3.65897 14.2656 2.98891 12.9994 2.68652 11.6667M18.3333 11.6667V16.6667M18.3333 11.6667H13.3333",
    stroke: "#404040",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33333C1.66666 8.33333 1.76776 7.62563 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967C16.341 5.73443 17.0111 7.0006 17.3135 8.33333M1.66666 8.33333V3.33333M1.66666 8.33333H6.66666M18.3333 11.6667C18.3333 11.6667 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C3.65897 14.2656 2.98891 12.9994 2.68652 11.6667M18.3333 11.6667V16.6667M18.3333 11.6667H13.3333",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33333C1.66666 8.33333 1.76776 7.62563 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967C16.341 5.73443 17.0111 7.0006 17.3135 8.33333M1.66666 8.33333V3.33333M1.66666 8.33333H6.66666M18.3333 11.6667C18.3333 11.6667 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C3.65897 14.2656 2.98891 12.9994 2.68652 11.6667M18.3333 11.6667V16.6667M18.3333 11.6667H13.3333",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33333C1.66666 8.33333 1.76776 7.62563 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967C16.341 5.73443 17.0111 7.0006 17.3135 8.33333M1.66666 8.33333V3.33333M1.66666 8.33333H6.66666M18.3333 11.6667C18.3333 11.6667 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C3.65897 14.2656 2.98891 12.9994 2.68652 11.6667M18.3333 11.6667V16.6667M18.3333 11.6667H13.3333",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 8.33333C1.66666 8.33333 1.76776 7.62563 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967C16.341 5.73443 17.0111 7.0006 17.3135 8.33333M1.66666 8.33333V3.33333M1.66666 8.33333H6.66666M18.3333 11.6667C18.3333 11.6667 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62563 18.2322 4.6967 15.3033C3.65897 14.2656 2.98891 12.9994 2.68652 11.6667M18.3333 11.6667V16.6667M18.3333 11.6667H13.3333",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.1f3ee1633022e5cb9d5d6640a3bf8ae4.svg";
export { ForwardRef as ReactComponent };